export const CHAT_SHARED_PAGES: RegExp[] = [
  // Dashboard Pages
  /^\/dashboard\/?$/,
  /^\/dashboard-error\/?$/,
  // Contact Us Pages
  /^\/contact\/?$/,
  // Profile & Setting Pages
  /^\/profile(\/.*)?$/,
]
